// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ZdUb","controls":"styles_controls__t9nwc","charLimit":"styles_charLimit__2yUZa","input":"styles_input__1WM6w","send":"styles_send__ku9hX"};